import { Component,ViewChild,ElementRef,OnInit, OnDestroy, HostListener, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmUploadDevicesComponent } from '../Dialogs/confirm-upload-devices/confirm-upload-devices.component';
import { DeviceService } from '../services/device-service/device.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../services/dialog-service/dialog.service';
import * as XLSX from 'xlsx';
import { ChangeDetectorRef } from '@angular/core';
import { saveAs } from 'file-saver';
import { ExcelLogsDownloadService } from '../services/logs-download/excel-logs-download.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import { CommonService } from '../services/common.service';
import { CanComponentDeactivate } from '../guards/unsaved-changes.guard';
import { UnsavedChangesTrackerService } from '../services/unsaved-changes/unsaved-changes-tracker.service';
import { UnsavedChangesHostHelper } from '../services/unsaved-changes/unsaved-changes-host.helper';
import {
  CUSTOMER_DROPDOWN_SELECT_LABEL,
  getGroupDropdownEmptyLabel,
  hasConcreteCustomerSelected,
  isGroupDropdownDisabled,
} from '../services/group-dropdown.util';

const ONBOARDING_DIRTY_SOURCE = 'onboarding-upload-form';

@Component({
  selector: 'app-onboarding',
  standalone: true,
  imports: [CommonModule, MatIconModule, FormsModule, HttpClientModule,MatDialogModule,RouterLink],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  @ViewChild('uploadArea', { static: true }) uploadArea!: ElementRef<HTMLDivElement>;
  @ViewChild('fileInput', { static: true }) fileInput!: ElementRef<HTMLInputElement>;
  customers: any[] = [];
  groups: any[] = [];
  groupsLoaded = true;
  selectedCustomer: string = '';
  selectedGroup: string = '';
  selectedCustomerGroupId: string = '';
  readonly customerDropdownSelectLabel = CUSTOMER_DROPDOWN_SELECT_LABEL;
  fileToUpload: File | null = null;
  borderColor = '#e5e5e5';
  uploadText = 'Please format data as a XLSX file as per given template';
  dialogRef:any;
  dialogRefs:any;
  hideCsvTemp:boolean=true;
  uploadSectionElement: HTMLElement | null = null;
  obj={
    customerId:this.selectedCustomer,
    otaGroupId:this.selectedGroup
  }
  errObj:any={}
  errArr:any=[]
  private apiUrl = environment.apiUrl;

  private readonly destroyRef = inject(DestroyRef);
  private readonly unsavedChanges = inject(UnsavedChangesTrackerService);
  private readonly unsavedHost = new UnsavedChangesHostHelper(
    this.unsavedChanges,
    inject(MatDialog),
    inject(Router)
  );

  constructor(private http: HttpClient,public dialog:MatDialog, public deviceService:DeviceService,
    public toaster:ToastrService, public dialogService: DialogService,  private cdr: ChangeDetectorRef,
    public excelDownloadService:ExcelLogsDownloadService, public commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.uploadSectionElement = document.querySelector('.upload-section');
    this.fetchCustomers();
    //this.fetchGroups();
    this.dialogService.click$.subscribe(()=>{
      this.uploadFile();
    })
    this.dialogService.cancelDialogWindow$.subscribe(()=>{
      if(this.dialogRef!=undefined)
      {
        this.dialogRef.close()
      }
    })
    this.dialogService.resetUpload$.subscribe(() => {
      this.fileToUpload = null;
      this.uploadText = 'Please format data as a XLSX file with a single column of device IDs';
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
      this.syncUnsavedChangesState();
    });

    this.unsavedChanges.discardRequested$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.resetFormState());
  }

  ngOnDestroy(): void {
    this.unsavedHost.clearOnDestroy();
  }

  canDeactivate(): Promise<boolean> {
    return this.unsavedHost.canDeactivate();
  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowBeforeUnload(event: BeforeUnloadEvent): void {
    this.unsavedHost.onBeforeUnload(event);
  }

  private hasUnsavedFormInput(): boolean {
    return (
      !!this.selectedCustomer ||
      !!this.selectedGroup ||
      !!this.fileToUpload
    );
  }

  private syncUnsavedChangesState(): void {
    this.unsavedChanges.setDirty(
      ONBOARDING_DIRTY_SOURCE,
      this.hasUnsavedFormInput()
    );
  }

  get groupDropdownEmptyLabel(): string {
    return getGroupDropdownEmptyLabel(
      hasConcreteCustomerSelected(this.selectedCustomer),
      this.groups?.length ?? 0,
      this.groupsLoaded
    );
  }

  get isGroupDropdownDisabled(): boolean {
    return isGroupDropdownDisabled(
      hasConcreteCustomerSelected(this.selectedCustomer),
      this.groups?.length ?? 0,
      this.groupsLoaded
    );
  }

  private resetFormState(): void {
    this.selectedCustomer = '';
    this.selectedGroup = '';
    this.selectedCustomerGroupId = '';
    this.customerName = '';
    this.groupName = '';
    this.groups = [];
    this.fileToUpload = null;
    this.isFileUploaded = false;
    this.uploadText = 'Please format data as a XLSX file as per given template';
    this.obj = { customerId: '', otaGroupId: '' };
    this.dialogService.selectedCustomerId = '';
    this.dialogService.selectedCustomerName = '';
    this.dialogService.selectedGroupId = '';
    this.dialogService.selectedGroupName = '';
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.groupsLoaded = true;
    this.unsavedChanges.clear(ONBOARDING_DIRTY_SOURCE);
  }
  customerName:any
  groupName:any
  onCustomerChange(event:any)
  {

    this.selectedCustomer=event.target.value;
    this.selectedGroup = '';
    this.selectedCustomerGroupId = '';
    this.groupName = '';
    this.dialogService.selectedGroupId = '';
    this.dialogService.selectedGroupName = '';
    this.obj['otaGroupId'] = '';
    if(this.selectedCustomer!='')
    {
      this.groups = [];
      this.groupsLoaded = false;
      this.deviceService.getOtagroupIdList(this.selectedCustomer).subscribe((response: any) => {
        this.groups = response.data.content || []; // Update based on API response structure
        this.groupsLoaded = true;
        this.selectedGroup = '';
        this.selectedCustomerGroupId = '';
        this.groupName = '';
        this.obj['otaGroupId'] = '';
        this.dialogService.selectedGroupId = '';
        this.dialogService.selectedGroupName = '';
      });
    }else{
      this.groups = [];
      this.groupsLoaded = true;
    }
    this.customerName=event.target.options[event.target.selectedIndex].text;
    this.dialogService.selectedCustomerId=event.target.value;
    this.dialogService.selectedCustomerName= event.target.options[event.target.selectedIndex].text;
    this.obj['customerId']=event.target.value;
    this.syncUnsavedChangesState();
  }
  navigateToOnboarding(): void {
    this.commonService.reloadComponent();
  }
  onGroupChange(event:any)
  {
    this.selectedGroup=event.target.value;
    this.groupName=event.target.options[event.target.selectedIndex].text;
    this.dialogService.selectedGroupId=event.target.value;
    this.dialogService.selectedGroupName= event.target.options[event.target.selectedIndex].text;
    this.obj['otaGroupId']=event.target.value;
    const selectedGroupObj = this.groups.find(g => String(g.id) === String(event.target.value));
    this.selectedCustomerGroupId = selectedGroupObj?.customerGroupId ?? '';
    this.syncUnsavedChangesState();
  }

  fetchCustomers(): void {
    const payload = {
      page: 0,
      size: 500,
      filters: [
        {
          field: 'customerName',
          operator: '',
          value: ''
        }
      ],
      sorts: [
        {
          field: 'customerName',
          direction: 'asc'
        }
      ]
    };

   this.deviceService.getCustomerList(payload).subscribe((response: any) => {
    this.customers = response.data.content || [];
  });
  }


  isFileUploaded:boolean=false
  onFileInputChange(event: any): void {
      const files: FileList = event.target.files;

      if (files && files.length > 0 ) {

        this.uploadText=files[0].name;
        let extension=this.uploadText.split('.').pop();
        if(extension == 'xlsx')
        {
          this.fileToUpload = files[0];
          this.isFileUploaded=true;
          data: { fileToUpload: this.fileToUpload }
        }
        else
        {
          this.fileToUpload=null;
          this.isFileUploaded=false;
          this.toaster.error('Please Upload XLSX file format',"Failed");
        }
        this.syncUnsavedChangesState();
      }
  }


  rowErrors:any;
  err400Key:any='';
  err400Value:any='';
  err:any;
  successCount:any=0;
  failureCount:any=0;
  showUploadButton:boolean=true;
  totalWarnings:number=0;
  arrWarnings:any;
  warningsKeyValue: { key: string; value: string }[] = [];
  errorKeyValue:{ key: string; value: string }[] = [];


  uploadFile(): void {
    if (!this.fileToUpload) {
      this.toaster.warning('Please select all fields and a file before uploading.');
      return;
    }

    // Reject empty / header-only Excel before starting device processing (Bug 3517).
    void this.validateExcelHasDeviceData(this.fileToUpload)
      .then((hasDeviceData) => {
        if (!hasDeviceData) {
          const fileName = this.fileToUpload?.name?.trim() || 'file';
          this.toaster.error(
            `No Device Data found in uploaded "${fileName}" file.`,
            'Error: ',
            { toastClass: 'ngx-toastr toast-error onboarding-excel-toast' }
          );
          return;
        }
        this.performDeviceUpload();
      })
      .catch(() => {
        this.toaster.error('Unable to read Excel file. Please try again.', 'Failed');
      });
  }

  /**
   * Client-side check matching BE bulkUploadExcel empty/header-only guard:
   * sheet must have at least one data row with content beyond the header.
   */
  private validateExcelHasDeviceData(file: File): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const buffer = reader.result;
          if (!(buffer instanceof ArrayBuffer) || buffer.byteLength === 0) {
            resolve(false);
            return;
          }
          const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array' });
          if (!workbook.SheetNames?.length) {
            resolve(false);
            return;
          }
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          if (!sheet) {
            resolve(false);
            return;
          }
          const rows = XLSX.utils.sheet_to_json<(string | number | boolean | null)[]>(
            sheet,
            { header: 1, defval: '', blankrows: false }
          );
          // rows[0] is the header; need ≥1 non-empty data row after it.
          if (!Array.isArray(rows) || rows.length <= 1) {
            resolve(false);
            return;
          }
          const hasDataRow = rows.slice(1).some(
            (row) =>
              Array.isArray(row) &&
              row.some((cell) => String(cell ?? '').trim() !== '')
          );
          resolve(hasDataRow);
        } catch {
          reject(new Error('Failed to parse Excel file'));
        }
      };
      reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'));
      reader.readAsArrayBuffer(file);
    });
  }

  private performDeviceUpload(): void {
    if (!this.fileToUpload) {
      return;
    }

    this.clearProcessingResults();
    this.showUploadButton = false;
    this.hideCsvTemp = false;

    const formData = new FormData();
    formData.append('file', this.fileToUpload);
    this.deviceService
      .upload(formData, this.selectedCustomer, this.selectedCustomerGroupId)
      .subscribe({
        next: (response) => {
          this.totalWarnings = response.data.warnings;
          if (response.data.failureCount != 0) {
            if (this.uploadSectionElement) {
              (this.uploadSectionElement as HTMLElement).style.display = 'none';
            }
            this.failureCount = response.data.failureCount;
            this.err = null;
            this.hideShowErrSuccess = true;
            this.rowErrors = response.data.rowErrors;
            this.errorKeyValue = this.rowErrors.flatMap((row: any) =>
              row.errors.map((error: any) => {
                const [key, value] = error.split(':').map((part: any) => part.trim());
                return { key, value };
              })
            );
            this.errArr = this.errorKeyValue;
          }

          if (response.data.warnings.length != 0 && response.data.warnings != null) {
            if (this.uploadSectionElement) {
              (this.uploadSectionElement as HTMLElement).style.display = 'none';
            }
            this.totalWarnings = response.data.warnings;
            this.err = null;
            this.hideShowErrSuccess = true;
            this.arrWarnings = response.data.warnings;
            this.warningsKeyValue = this.arrWarnings.map((warning: any) => {
              const [key, value] = warning.split(':');
              return { key: key.trim(), value: value.trim() };
            });
          }

          if (response.data.successCount != 0) {
            if (this.uploadSectionElement) {
              (this.uploadSectionElement as HTMLElement).style.display = 'none';
            }
            this.err = null;
            this.hideShowErrSuccess = true;
            this.successCount = response.data.successCount;
            console.log(this.successCount);
            this.toaster.success('File uploaded successfully!', 'success');
          }

          this.uploadText = '';
          this.dialogService.closeDialog();
          if (this.dialogRef != undefined) {
            this.dialogRef.close();
          } else if (this.dialogRefs != undefined) {
            this.dialogRefs.close();
          }
          this.unsavedChanges.clear(ONBOARDING_DIRTY_SOURCE);
        },
        error: (err) => {
          this.err = err;
          if (this.uploadSectionElement) {
            (this.uploadSectionElement as HTMLElement).style.display = 'none';
          }
          this.hideShowErrSuccess = true;
          if (this.err.status == 400 || 500) {
            this.successCount = 0;
            this.rowErrors = null;
            if (this.err.error.title) {
              this.err400Key = this.err.error.title;
              this.err400Value = this.err.error.detail[0];
              this.errObj = {
                key: this.err400Key,
                value: this.err400Value,
              };
            }
            if (this.err.error.message) {
              this.err400Key = this.err.error.message;
              this.err400Value = this.err.error.details[0];
              this.errObj = {
                key: this.err400Key,
                value: this.err400Value,
              };
            }
            this.errArr.push(this.errObj);
            if (this.dialogRef != undefined) {
              this.dialogRef.close();
            } else if (this.dialogRefs != undefined) {
              this.dialogRefs.close();
            }

            this.toaster.error('File upload failed. Please try again.');
          }
        },
      });
  }

  triggerFileInput() {
    this.fileInput?.nativeElement.click();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.borderColor = '#ff6b35';
  }

  onDragLeave() {
    this.borderColor = '#e5e5e5';
  }

  onFileDrop(event: DragEvent) {
    this.err=null
    this.successCount=0
    this.rowErrors=null
    event.preventDefault();
    this.borderColor = '#e5e5e5';
    const files = event.dataTransfer?.files;
    this.uploadText = `Selected file: ${files?.item(0)?.name}`;
    if (files?.length) {
      let extension=this.uploadText.split('.').pop();
      if(extension == 'xlsx')
      {
        this.fileToUpload = files[0];
        this.isFileUploaded=true;
      }
      else
      {
        //this.fileToUpload=null;
        this.toaster.error('Please Upload XLSX file format',"Failed");
      }
      this.syncUnsavedChangesState();
    }
  }

  hideShowErrSuccess:boolean=false

  /**
   * Returns to the upload form after results are shown.
   * Customer and Group stay selected so a corrected file can be processed again.
   */
  reuploadCorrectedFile(): void {
    this.clearProcessingResults();
    this.hideShowErrSuccess = false;
    this.showUploadButton = true;
    this.hideCsvTemp = true;
    this.fileToUpload = null;
    this.isFileUploaded = false;
    this.uploadText = 'Please format data as a XLSX file as per given template';
    this.borderColor = '#e5e5e5';
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    if (this.uploadSectionElement) {
      this.uploadSectionElement.style.display = '';
    }
    this.syncUnsavedChangesState();
  }

  private clearProcessingResults(): void {
    this.successCount = 0;
    this.failureCount = 0;
    this.totalWarnings = 0;
    this.rowErrors = null;
    this.errorKeyValue = [];
    this.warningsKeyValue = [];
    this.arrWarnings = [];
    this.errArr = [];
    this.err = null;
    this.err400Key = '';
    this.err400Value = '';
    this.errObj = {};
  }

  onCancel(): void {
    this.resetFormState();
  }
  downloadSavedLogs()
  {
    this.excelDownloadService.exportToExcel(this.errArr, 'error logs');
  }

  downloadExcelFile() {
    // Define the data with headers
    const data = [
      ['gatewayId', 'esim', 'sim', 'carrierProfileName', 'serialNumber', 'iccid', 'imei'],
    ];

    // Create a new workbook and a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Device_Template');

    // Generate an Excel file and trigger download
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'device_upload_template.xlsx';
    document.body.appendChild(link)
  ;
    link.click();
    document.body.removeChild(link)
  ;
  }
}
